import React from 'react';

const TextWidget = ({ settings, value, onChange }) => {
  const widgetType = settings?.type || 'text';

  // Map widget types to HTML input types
  const inputType = {
    'email': 'email',
    'phone': 'tel',
    'url': 'url',
    'text': 'text',
  }[widgetType] || 'text';

  const placeholder = {
    'email': 'name@example.com',
    'phone': '201-555-0100',
    'url': 'https://',
    'text': '',
  }[widgetType] || '';

  const inputStyle = {
    padding: '8px 12px',
    border: '1px solid #ccc',
    borderRadius: '6px',
    fontSize: '0.9rem',
    outline: 'none',
    width: '250px',
  };

  return (
    <input
      type={inputType}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      style={inputStyle}
    />
  );
};

export default TextWidget;
